import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import PDFUploader from '../molecules/PDFUploader';
import FloatingModelsContainer from '../organisms/FloatingModelsContainer';
import { useChat } from '../../context/ChatContext';
import './LandingTemplate.css';

const LandingTemplate = ({ onStartClick, onPdfTextExtracted }) => {
  const navigate = useNavigate();
  const [extractedText, setExtractedText] = useState('');
  const { resetConversation } = useChat();

  const handleTextExtracted = (text) => {
    setExtractedText(text);
    // Reset any existing conversation when a new PDF is uploaded
    resetConversation();
    if (onPdfTextExtracted) {
      onPdfTextExtracted(text);
    }
  };

  const handleStartClick = () => {
    // Start a new conversation with the PDF content
    if (onStartClick) {
      onStartClick();
    }
  };

  const handleChapterSelect = () => {
    navigate('/chapters');
  };

  return (
    <div className="landing-template">
      {/* Gradient orbs */}
      <div className="gradient-orb"></div>
      <div className="gradient-orb"></div>
      <div className="gradient-orb"></div>
      <div className="gradient-orb"></div>
      
      <FloatingModelsContainer />
      
      <div className="landing-content glass-card">
        <div className="landing-header">
          <div className="interview-icon">AI</div>
          <Typography variant="h1" color="white" align="center" className="heading-xl landing-title">
            Super Astronaut Tutor
          </Typography>
          <Typography variant="subtitle1" color="dark" align="center" className="landing-subtitle">
            Learn physics, astronomy and related sciences with our AI-powered tutor
          </Typography>
          {extractedText && (
            <Typography variant="body2" color="success" align="center" className="pdf-success">
              Study material loaded! Start the tutoring session to begin learning.
            </Typography>
          )}
        </div>
        
        <div className="learning-options">
          <div className="option-card">
            <Typography variant="h3" color="white" align="center" className="option-title">
              Upload Study Material
            </Typography>
            <PDFUploader onTextExtracted={handleTextExtracted} />
            
            <Button 
              onClick={handleStartClick} 
              variant="primary" 
              size="large"
              className="btn btn-primary landing-cta"
              disabled={!extractedText}
            >
              Start Tutoring Session
            </Button>
            
            {!extractedText && (
              <Typography variant="caption" color="dark" align="center" className="upload-hint">
                Upload study material as PDF to begin a personalized tutoring session
              </Typography>
            )}
          </div>
          
          <div className="option-divider">
            <span>OR</span>
          </div>
          
          <div className="option-card">
            <Typography variant="h3" color="white" align="center" className="option-title">
              30-Day Physics Plan
            </Typography>
            <Typography variant="body2" color="dark" align="center" className="option-description">
              Choose from our 30-day physics curriculum covering mechanics, thermodynamics, optics, electromagnetism, and more.
            </Typography>
            
            <Button 
              onClick={handleChapterSelect} 
              variant="secondary" 
              size="large"
              className="btn btn-secondary landing-cta"
            >
              View Physics Chapters
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingTemplate; 